'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var Skeleton_module = require('../styles/Skeleton.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description Provide a placeholder while you wait for content to load, or to visualise content that doesn't exist yet
 *
 * @component
 * @example
 * ```jsx
 * <Skeleton />
 * ```
 */
const Skeleton = React__namespace.forwardRef((props, ref) => {
    const { className, children, ...restProps } = props;
    const cx = reactUtils.useStyles(Skeleton_module.default);
    const classNames = cx(className, 'container');
    return (React__namespace.createElement("div", { ref: ref, "data-qa": "Skeleton", className: classNames, ...restProps }, children));
});
Skeleton.defaultProps = {};
Skeleton.displayName = 'Skeleton';

exports.Skeleton = Skeleton;
//# sourceMappingURL=Skeleton.js.map
